// mixin.js file
export default {
  methods: {
    round(value, digits) {
      var digitsToUse = 3;
      if (digits !== undefined) {
        digitsToUse = digits;
      }

      var power = Math.pow(10, digitsToUse);
      var preciseResult = Math.round(value * power) / power;
      return digits !== undefined ? preciseResult : preciseResult.toFixed(3);
    }
  }
};
